import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import CustomButton from '../../../../shared/components/buttons/custom-button/custom-button';
import { DocumentAddIcon } from '../../../../shared/icons/document-add-icon';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import { setActiveRequestId } from '../../../request/store/requests-slice';
import { openModal } from '../../../ui/store/ui-slice';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import ScanRequestsContent from '../../components/scan-requests-content/scan-requests-content';
import { scanRequestAlertId, scanRequestFormModalId } from '../../constants/constants';
import { setActiveScanRequestId, setIsScanRequestPreviewOpen } from '../../store/scan-requests-slice';

const ScanRequests = (): JSX.Element => {
  const { t } = useTranslation(['scan-requests', 'common']);
  const dispatch = useDispatch();

  const openCreateScanRequestModal = () => {
    dispatch(openModal(scanRequestFormModalId));
  };

  useEffect(() => {
    return () => {
      dispatch(setActiveRequestId(null));
      dispatch(setActiveScanRequestId(null));
      dispatch(setIsScanRequestPreviewOpen(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthGuard permission={UserPermissionType.ViewDocuments}>
      <Helmet>
        <title>{t('menu.scanRequests', { ns: 'common' })}</title>
      </Helmet>
      <LayoutInner
        alertId={scanRequestAlertId}
        headerActionButton={
          <CustomButton
            type="primaryLight"
            htmlType="button"
            onClick={openCreateScanRequestModal}
            icon={<DocumentAddIcon />}
          >
            {t('action.newScanRequest')}
          </CustomButton>
        }
      >
        <ScanRequestsContent />
      </LayoutInner>
    </AuthGuard>
  );
};

export default ScanRequests;
